import { useContext, useState } from 'react';
import { StyleContext } from '../../providers/StyleContextProvider';
import { ReactComponent as ExternalLink } from '../../assets/svg/external-link.svg';
import { Button } from "../Shared/Buttons/Button";
import { DocumentViewer } from "../Shared/DocumentViewer";
import { PopUpWindow } from "../Shared/PopUpWindow";
import { getCandidateCVUrlByRecruiter } from "../../helpers/Common";
import { downloadCandidateResume } from '../../services/CandidateService';
import useErrorPage from '../../hooks/useErrorPage';
import { UserType } from '../../enums/UserType';

interface Props {
    cvTranslationText: string;
    cvFileName?: string;
    recruiterId: number;
    token: string;
}

export const CVTab: React.FC<Props> = (props) => {
    const styleContext = useContext(StyleContext);
    const tabStyles = styleContext.getComponentStyle("candidatePoolTabs");
    const styles = tabStyles.cvTab;
    const [openCVPopup, setOpenCVPopup] = useState<boolean>(false);
    const [toErrorPage] = useErrorPage();

    async function downloadCandidateCV() {
        await downloadCandidateResume(props.cvTranslationText, props.cvFileName)
        .then((response: any) => {
            
        })
        .catch((error) => {
            toErrorPage(error, UserType.Recruiter);            
        });
    }

    return (
        <>
            <div>
                <div style={styles.rowWrapper}>
                    <div style={styles.text}>CV</div>
                    <div style={styles.link} onClick={() => setOpenCVPopup(true)}>
                        View Full Screen <ExternalLink style={styles.icon} />
                    </div>
                    <Button style={styles.button} onClick={downloadCandidateCV}>{"Download"}</Button>
                </div>
                <div style={styles.holder}>
                    <div style={styles.layer}></div>
                    <p style={styles.name}>{props.cvFileName}</p>
                    <DocumentViewer document={getCandidateCVUrlByRecruiter(props.recruiterId, props.cvTranslationText, props.token)} styles={styles.documentViewer}/>
                </div>
            </div>
            <PopUpWindow styles={styles.popup} open={openCVPopup} toggle={() => setOpenCVPopup(!openCVPopup)} closeCircle={true}>
                <DocumentViewer document={getCandidateCVUrlByRecruiter(props.recruiterId, props.cvTranslationText, props.token)} styles={styles.documentViewer}/>                
            </PopUpWindow> 
        </>
    );
}